import { ColumnSelectionFilter } from './ColumnSelectionFilter';
import {
  useActivityLogsTableStore,
  initialActivityLogsColumns,
} from 'store/activityLogsTable.store';
import { Button } from '@mui/material';
import { ColumnPreferencesConfig } from '@common/types';

const MIN_VISIBLE_COLUMNS = 4;

type ActivityLogsColumnKey =
  | 'title'
  | 'timestamp'
  | 'recorded_minutes'
  | 'provider'
  | 'created_at'
  | 'related_entity'
  | 'action';

const ACTIVITY_LOGS_COLUMN_LABELS: Record<ActivityLogsColumnKey, string> = {
  title: 'Title',
  timestamp: 'Timestamp',
  recorded_minutes: 'Minutes',
  provider: 'Provider',
  created_at: 'Created at',
  related_entity: 'Related entity',
  action: 'Actions',
};

const ALL_FIELDS = initialActivityLogsColumns.map(
  c => c.field,
) as ActivityLogsColumnKey[];

export const ActivityLogsTableColumnSelectionFilter = ({
  hideText,
}: {
  hideText?: boolean;
}) => {
  const hiddenColumns = useActivityLogsTableStore(s => s.hiddenColumns);
  const setHiddenColumns = useActivityLogsTableStore(s => s.setHiddenColumns);

  const columns: Partial<
    Record<ActivityLogsColumnKey, ColumnPreferencesConfig>
  > = Object.fromEntries(
    ALL_FIELDS.map((field, index) => [
      field,
      {
        column_display: hiddenColumns.includes(field) ? 'hidden' : 'display',
        column_order: index,
        column_size: 160,
      } satisfies ColumnPreferencesConfig,
    ]),
  );

  const handleSelectionChange = (
    selection: Partial<Record<ActivityLogsColumnKey, ColumnPreferencesConfig>>,
  ) => {
    const nextHidden = ALL_FIELDS.filter(
      field => selection[field]?.column_display === 'hidden',
    );
    const visibleCount = ALL_FIELDS.length - nextHidden.length;
    if (visibleCount < MIN_VISIBLE_COLUMNS) return;
    setHiddenColumns(nextHidden);
  };

  return (
    <ColumnSelectionFilter
      name='activity_logs_table_columns'
      label='Columns'
      hideText={hideText}
      columns={columns}
      columnLabels={ACTIVITY_LOGS_COLUMN_LABELS}
      onChange={handleSelectionChange}
      footerAction={
        <Button color='primary' onClick={() => setHiddenColumns([])}>
          RESET
        </Button>
      }
    />
  );
};
